/**
 * Legend for tracker map and store list: operational status colours (By Store aligned).
 */

import React from "react";
import type { TrackerOperationalStatus } from "@shared/tracker-types";
import {
  OPERATIONAL_STATUS_COLORS,
  REJECTION_INDICATOR_COLOR,
} from "@shared/tracker-operational-status";

const LEGEND_ITEMS: { status: TrackerOperationalStatus; label: string }[] = [
  { status: "NOT_STARTED", label: "Not started" },
  { status: "IN_PROGRESS", label: "In progress" },
  { status: "COMPLETE", label: "Operator complete" },
];

export function TrackerMapLegend() {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-muted-foreground">
      {LEGEND_ITEMS.map(({ status, label }) => (
        <div key={status} className="flex items-center gap-1.5">
          <span
            className="w-2.5 h-2.5 rounded-full flex-shrink-0"
            style={{ backgroundColor: OPERATIONAL_STATUS_COLORS[status] }}
            aria-hidden
          />
          <span>{label}</span>
        </div>
      ))}
      <div className="flex items-center gap-1.5">
        <span
          className="w-2.5 h-2.5 rounded-full flex-shrink-0 ring-2 ring-offset-1"
          style={{ backgroundColor: OPERATIONAL_STATUS_COLORS.IN_PROGRESS, outlineColor: REJECTION_INDICATOR_COLOR }}
          aria-hidden
        />
        <span>Has admin rejections (orange pin)</span>
      </div>
    </div>
  );
}
